require('dom-slider');

const { slideToggle, slideUp } = window.domSlider;

const cards = document.querySelectorAll('.block-card-expand');
const cardsContainer = document.querySelectorAll(
	'.block-cards-expanding__container'
);

const toggleCard = (e) => {
	e.preventDefault();

	const card = e.currentTarget.closest('.block-card-expand');
	const parentContainer = e.currentTarget.closest(
		'.block-cards-expanding__container'
	);
	const expandContent = card.querySelector(
		'.block-card-expand__expanded-content'
	);
	const currentActive = parentContainer.querySelector(
		'.block-card-expand.active'
	);

	let cardType;
	if (card.classList.contains('block-card-expand--one-third')) {
		cardType = 'third';
	} else {
		cardType = 'half';
	}

	if (currentActive && currentActive !== card) {
		currentActive.style.marginBottom = '0';
		currentActive.classList.remove('active');
		resetAccordions(currentActive);
		checkActiveCards();
	}

	card.classList.toggle('active');
	const cardHeight = getCardHeights(expandContent);
	const imageHeight = getImageHeight(card, cardType);

	if (card.classList.contains('active')) {
		if (cardType !== 'third') {
			card.style.marginBottom = `calc(${cardHeight}px - 28%)`;
		} else {
			card.style.marginBottom = `calc(${cardHeight}px - 22%)`;
		}
		updateExpandHeight(expandContent, imageHeight, card, scrollToCard);
		checkActiveCards();
	} else {
		card.style.marginBottom = '0';
		resetAccordions(card);
		checkActiveCards();
	}
};

const resetAccordions = (card) => {
	const accordionItems = card.querySelectorAll(
		'.block-card-expand__accordion-item'
	);

	if (accordionItems.length) {
		accordionItems.forEach((accordionItem) => {
			const accordionButton = accordionItem.querySelector(
				'.wp-block-button .wp-block-button__link'
			);

			accordionButton.classList.remove('active');
			accordionItem.classList.remove('active');
			const accordionContent = accordionItem.querySelector(
				'.block-card-expand__accordion-item > .block-card-expand__accordion-content'
			);

			if (accordionContent) {
				slideUp({
					element: accordionContent,
					slideSpeed: 0,
				});
			}
		});
	}
};

const initAccordions = () => {
	const accordionButtons = document.querySelectorAll(
		'.block-card-expand__accordion-item > .wp-block-button .wp-block-button__link'
	);

	const accordionItems = document.querySelectorAll(
		'.block-card-expand__accordion-item'
	);

	if (accordionButtons.length) {
		accordionButtons.forEach((accordionButton) => {
			accordionButton.addEventListener('click', toggleCardAccordion);
		});
	}

	if (accordionItems.length) {
		accordionItems.forEach((accordionItem) => {
			const accordionContent = accordionItem.querySelector(
				'.block-card-expand__accordion-item > .block-card-expand__accordion-content'
			);

			if (accordionContent) {
				slideUp({
					element: accordionContent,
					slideSpeed: 0,
				});
			}
		});
	}
};

const toggleCardAccordion = (e) => {
	e.preventDefault();
	e.stopPropagation();
	const currentItem = e.currentTarget.closest(
		'.block-card-expand__accordion-item'
	);
	currentItem.querySelector('.wp-block-button__link').disabled = true;
	const accordionBlock = e.currentTarget.closest(
		'.block-card-expand__accordion '
	);

	const expandContent = e.currentTarget.closest(
		'.block-card-expand__expanded-content'
	);

	if (currentItem && accordionBlock) {
		currentItem.classList.toggle('active');
		e.currentTarget.classList.toggle('active');

		const currentContent = currentItem.querySelector(
			'.block-card-expand__accordion-item > .block-card-expand__accordion-content'
		);
		const card = e.currentTarget.closest('.block-card-expand');

		let cardType;
		if (card.classList.contains('block-card-expand--one-third')) {
			cardType = 'third';
		} else {
			cardType = 'half';
		}

		slideToggle({
			element: currentContent,
			slideSpeed: 400,
			easing: 'ease-in-out',
		}).then(() => {
			const cardHeight = getCardHeights(expandContent);
			//card.style.marginBottom = `calc(${cardHeight}px - 28%)`;
			if (cardType !== 'third') {
				card.style.marginBottom = `calc(${cardHeight}px - 28%)`;
			} else {
				card.style.marginBottom = `calc(${cardHeight}px - 22%)`;
			}
			currentItem.querySelector(
				'.wp-block-button__link'
			).disabled = false;
		});

		if (accordionBlock.classList.contains('is-style-single-open')) {
			const activeItemContents = accordionBlock.querySelectorAll(
				'.block-card-expand__accordion-item.active > .block-card-expand__accordion-content'
			);

			if (activeItemContents.length) {
				activeItemContents.forEach((activeItemContent) => {
					if (activeItemContent !== currentContent) {
						activeItemContent.parentElement.classList.remove(
							'active'
						);

						slideUp({
							element: activeItemContent,
							slideSpeed: 400,
							easing: 'ease-in-out',
						});
					}
				});
			}
		}
	}
};

const scrollToCard = (card) => {
	card.scrollIntoView({ behavior: 'smooth' }, true);
};

const updateExpandHeight = (expandContent, imageHeight, card, callback) => {
	expandContent.style.transform = `translate(0, -${imageHeight}px)`;
	setTimeout(function () {
		if (callback) {
			callback(card);
		}
	}, 500);
};

const getCardHeights = (card) => {
	const cardOffset = 150;

	const cardHeight = card.getBoundingClientRect().height + cardOffset;
	return cardHeight;
};

const getImageHeight = (card, cardType) => {
	let imageHeight =
		card
			.querySelector('.block-card-expand__image-wrapper')
			.getBoundingClientRect().height / 2;
	let cardOffset = 45;
	if (cardType === 'third') {
		cardOffset = -60;
	}

	imageHeight = imageHeight + cardOffset;

	return imageHeight;
};

const checkActiveCards = () => {
	if (cardsContainer.length) {
		cardsContainer.forEach((container) => {
			const activeCard = container.querySelector(
				'.block-card-expand.active'
			);
			if (activeCard) {
				container.classList.add(
					'block-cards-expanding__container--open'
				);
			} else {
				container.classList.remove(
					'block-cards-expanding__container--open'
				);
			}
		});
	}
};

const resizeActiveCard = () => {
	const activeCards = document.querySelectorAll('.block-card-expand.active');
	if (activeCards.length) {
		activeCards.forEach((card) => {
			const expandContent = card.querySelector(
				'.block-card-expand__expanded-content'
			);

			const cardHeight = getCardHeights(expandContent);
			let imageHeight = getImageHeight(card, cardType);

			let cardType;
			if (card.classList.contains('block-card-expand--one-third')) {
				cardType = 'third';
				imageHeight = imageHeight - 107;
			} else {
				cardType = 'half';
				imageHeight = imageHeight - 117;
			}

			card.style.marginBottom = `calc(${cardHeight}px - 25%)`;
			updateExpandHeight(expandContent, imageHeight, null, null);
		});
	}
};

const expandCard = () => {
	if (cards.length) {
		cards.forEach((card) => {
			const expandButton = card.querySelector(
				'.block-card-expand__expand'
			);
			if (expandButton) {
				expandButton.addEventListener('click', toggleCard);
			}
		});
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		expandCard();
		initAccordions();
	},
	loaded() {},
	resized() {
		resizeActiveCard();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
